/* eslint-disable @nx/enforce-module-boundaries */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { BrandFilter } from '@marriott/mi-shop-components';
import { StyledSearchAllFilters } from './PropertiesListFilter.styles';
import clsx from 'clsx';
import { Button, Modal, CheckboxControlsList } from '@marriott/mi-ui-library';
import { useEffect, useState } from 'react';
import {
  BrandProps,
  CheckboxControlsListProps,
  ControlsProps,
  availableBrandsType,
  brandCategoriesDataType,
  brandCategoryTitleMappingType,
  brandFilterProps,
} from './PropertiesListFilter.types';
import { INTERNAL_CTA_TYPE } from 'libs/mi-offers-components/src/constants/CommonConstants';
import { usePersistentGlobalStore } from '@marriott/mi-store-utils';
import { ShowPriceTaxFilter } from './priceTaxFilter/priceTaxFilter';

export const PropertiesListFilter: React.FC<any> = props => {
  const globalData = usePersistentGlobalStore((state: any) => state.globalData);
  const ariesOffer = globalData?.sessionData?.cacheData?.data?.AriesOffer;
  const [popupOpenState, setPopupOpenState] = useState<boolean>(false);
  const [isNewFacetsLoading, setIsNewFacetsLoading] = useState<boolean>(props?.isNewFacetsLoading);
  const model = props.model;
  const [filterCategoryModal, setFilterCategoryModal] = useState<string>('All Filters');
  const [filterCategoryHeader, setFilterCategoryHeader] = useState<string>(model?.allFilters ?? 'All Filters');
  const [selectedBrands, setSelectedBrands] = useState<BrandProps[]>([]);
  const [selectedCountries, setSelectedCountries] = useState<ControlsProps[]>([]);
  const [selectedStates, setSelectedStates] = useState<ControlsProps[]>([]);
  const [selectedCities, setSelectedCities] = useState<ControlsProps[]>([]);
  const [isCategoryFilterModal, setIsCategoryFilterModal] = useState<boolean>(false);
  const [isTaxSliderActive, setIsTaxSliderActive] = useState<boolean>(props?.isTaxSliderActive);
  const isPreview = props?.isPreview ?? false;
  const isFilterSelected =
    ((props?.variation === 'sbo' ? 0 : ariesOffer?.['selectedBrands']?.length) ?? 0) +
    (ariesOffer?.['selectedCountries']?.length ?? 0) +
    (ariesOffer?.['selectedStates']?.length ?? 0) +
    (ariesOffer?.['selectedCities']?.length ?? 0);

  const brandCategoriesData: brandCategoriesDataType = [];
  useEffect(() => {
    setSelectedBrands(props.selectedBrands);
    setSelectedCountries(props?.selectedCountries);
    setSelectedStates(props?.selectedStates);
    setSelectedCities(props?.selectedCities);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.selectedBrands.length, props?.selectedCountries?.length, props?.selectedStates, props?.selectedCities]);

  useEffect(() => {
    setIsNewFacetsLoading(props?.isNewFacetsLoading);
  }, [props?.isNewFacetsLoading]);

  const brandCategoryTitleMapping: brandCategoryTitleMappingType = {
    luxuryBrands: model?.storefrontPropertyBrandFilterLuxury,
    premiumBrands: model?.storefrontPropertyBrandFilterPremium,
    selectBrands: model?.storefrontPropertyBrandFilterSelect,
    longerStayBrands: model?.storefrontPropertyBrandFilterLongerStay,
  };

  const getBrandCategoriesData = (brandCategory: string) => {
    const brandsList = model?.brands[brandCategory].map((brand: { code: string; title: string }) => {
      const isDisabled = props.availableBrands?.some((item: availableBrandsType) => {
        return item.code === brand.code;
      });
      return {
        code: brand?.code,
        brandTagTitle: brand?.title,
        description: '',
        brandTagId: brand?.code,
        isDisabled: !isDisabled,
      };
    });
    const key = brandCategory as keyof typeof brandCategoryTitleMapping; // to allow indexing on object
    const category = {
      categoryTitle: brandCategoryTitleMapping[key],
      categorySelectLabel: model?.storefrontPropertyBrandFilterSelectAll,
      categoryClearLabel: model?.storefrontPropertyFilterClear,
      brands: brandsList,
    };
    brandCategoriesData.push(category);
  };
  getBrandCategoriesData('luxuryBrands');
  getBrandCategoriesData('premiumBrands');
  getBrandCategoriesData('selectBrands');
  getBrandCategoriesData('longerStayBrands');

  const handleBrandFilter = (selectedBrandAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedBrands(selectedBrandAr);
    props.handleApplyFilter(false, selectedBrandAr, selectedCountries, selectedStates, selectedCities);
  };
  const handleCountryChange = (selectedCountriesAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedCountries(selectedCountriesAr);
    props.handleApplyFilter(false, selectedBrands, selectedCountriesAr, selectedStates, selectedCities);
  };
  const handleStateChange = (selectedStatesAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedStates(selectedStatesAr);
    props.handleApplyFilter(false, selectedBrands, selectedCountries, selectedStatesAr, selectedCities);
  };
  const handleCityChange = (selectedCitiesAr: any) => {
    setIsNewFacetsLoading(true);
    setSelectedCities(selectedCitiesAr);
    props.handleApplyFilter(false, selectedBrands, selectedCountries, selectedStates, selectedCitiesAr);
  };
  const toggleModal = () => {
    setPopupOpenState(!popupOpenState);
    setSelectedBrands(ariesOffer?.['selectedBrands'] ?? []);
    setSelectedCountries(ariesOffer?.['selectedCountries'] ?? []);
    setSelectedStates(ariesOffer?.['selectedStates'] ?? []);
    setSelectedCities(ariesOffer?.['selectedCities'] ?? []);
  };
  const handleDynamicPricesAndTax = (val: boolean) => {
    setIsTaxSliderActive(val);
  };
  const handleClearBtn = () => {
    setIsNewFacetsLoading(true);
    setSelectedBrands([]);
    setSelectedCountries([]);
    setSelectedStates([]);
    setSelectedCities([]);
    setIsTaxSliderActive(false);
    props.handleClearAllFilters();
  };
  const getControlsData = (currentFilterData: any) => {
    const desiredKeys = ['code', 'count', 'label', 'description'];
    const updatedFilterOptions = currentFilterData?.map((obj: any) => {
      const newFilterOptionsObj: any = {};
      desiredKeys?.forEach(key => {
        newFilterOptionsObj[key] = obj[key];
      });
      const modifiedLabel = obj?.label ?? obj?.description ?? obj?.code;
      return { ...newFilterOptionsObj, label: modifiedLabel };
    });
    return updatedFilterOptions;
  };
  //props received by BrandFilter
  const BrandFilterProps: brandFilterProps = {
    title: `${model?.storefrontPropertyBrandFilter}`,
    brandCategories: brandCategoriesData,
    showSeparator: false,
    // defaultSelected includes all those brands which are selected and highlited for filtering the properties.
    defaultSelected: selectedBrands,
    onChange: handleBrandFilter,
    isHotelBrandSelectedFlag: true,
  };
  //props received by country filter
  const CountryFilterProps: CheckboxControlsListProps = {
    title: `${model?.countryLabel ?? 'Country'}`,
    controls: getControlsData(props?.availableCountries),
    enableShowMoreToggle: true,
    defaultSelected: selectedCountries,
    onChange: handleCountryChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'filterCountry',
    showSeparator: true,
  };
  //props received by state filter
  const StateFilterProps: CheckboxControlsListProps = {
    title: `${model?.stateLabel ?? 'State'}`,
    controls: getControlsData(props?.availableStates),
    enableShowMoreToggle: true,
    defaultSelected: selectedStates,
    onChange: handleStateChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'filterState',
    showSeparator: true,
  };
  //props received by city filter
  const CityFilterProps: CheckboxControlsListProps = {
    title: `${model?.cityLabel ?? 'City'}`,
    controls: getControlsData(props?.availableCities),
    enableShowMoreToggle: true,
    defaultSelected: selectedCities,
    onChange: handleCityChange, //array of changed value
    showMoreCount: 8,
    showMoreLabel: `${model?.showMoreLabel ?? 'Show More'}`,
    showLessLabel: `${model?.showLessLabel ?? 'Show Less'}`,
    name: 'filterCity',
    showSeparator: true,
  };
  const getModalData = (): any => {
    if (filterCategoryModal === 'All Filters') {
      return (
        <>
          {props?.availableBrands?.length > 1 && (
            <>
              <BrandFilter {...BrandFilterProps} />
              <hr className="filter-separator" aria-hidden="true" />
            </>
          )}
          {CountryFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...CountryFilterProps} /> : null}
          {StateFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...StateFilterProps} /> : null}
          {CityFilterProps?.controls?.length > 0 ? <CheckboxControlsList {...CityFilterProps} /> : null}
        </>
      );
    } else if (filterCategoryModal === 'Brands') {
      return <BrandFilter {...BrandFilterProps} />;
    }
  };

  return (
    <StyledSearchAllFilters className="offer-filters">
      <div className="filter-btns-wrapper">
        <Button
          callback={(): void => {
            setFilterCategoryModal('All Filters');
            setFilterCategoryHeader(model?.allFilters ?? 'All Filters');
            toggleModal();
          }}
          className={clsx(
            `button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button ${
              isFilterSelected && 'active'
            }`
          )}
          custom_click_track_value={`${model?.id}|${model?.storefrontPropertyBrandFilter}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          trackingProperties={model?.trackingProperties}
        >
          <span className={`icon-s ${isFilterSelected ? ' all-filter-badge' : 'icon-dining-filter'}`}>
            {' '}
            {`${isFilterSelected ? isFilterSelected : ''}`}
          </span>
          {model?.allFilters}
        </Button>
        {props?.availableBrands?.length > 1 && (
          <Button
            callback={(): void => {
              setFilterCategoryModal('Brands');
              setFilterCategoryHeader(model?.storefrontPropertyBrandFilter);
              toggleModal();
            }}
            className={clsx(
              'button custom_click_track button--medium button-secondary m-button-primary-inverse t-label-alt-m filter-option-button',
              ariesOffer?.['selectedBrands']?.length > 0 ? 'active' : ''
            )}
            custom_click_track_value={`${model?.id}|${model?.storefrontPropertyBrandFilter}-${model?.storefrontPropertyFilters}|${INTERNAL_CTA_TYPE}`}
          >
            {model?.storefrontPropertyBrandFilter}
          </Button>
        )}
      </div>
      {popupOpenState && (
        <Modal
          className={`custom-scrollbar modal-main-container ${popupOpenState && 'close-popup-header'} ${
            isCategoryFilterModal && 'category-filter-modal'
          }`}
          show={true}
          handleBlur={true}
          popupOpenState={popupOpenState}
          setPopupOpenState={setPopupOpenState}
          disableScrollOnBody={true}
          allFilterPopUp={true}
          onClose={(): void => {
            setPopupOpenState(false);
          }}
        >
          {isNewFacetsLoading && (
            <div
              className="loader-container d-flex align-items-center justify-content-center"
              data-testid="facets-spinner"
            >
              <div className="m-spinner-m"></div>
            </div>
          )}
          <Modal.Header
            className="modal-header t-subtitle-xl"
            labelText={filterCategoryHeader}
            popupHeaderOnCLoseFunc={(): void => {
              setIsCategoryFilterModal(false);
              setPopupOpenState(false);
            }}
            closeIconClickTrackValue={`${model?.id}|close Modal|${INTERNAL_CTA_TYPE}`}
          />
          <Modal.Body className="all-filters custom-scrollbar">
            <div>
              {isPreview && (
                <ShowPriceTaxFilter
                  isTaxSliderActive={isTaxSliderActive}
                  handleDynamicPricesAndTax={handleDynamicPricesAndTax}
                  filterTaxesLabel={model?.filterTaxesLabel}
                />
              )}
              <div>{getModalData()}</div>
            </div>
          </Modal.Body>
          <Modal.Footer
            clearClickHandler={handleClearBtn}
            setPopUpOpenState={setPopupOpenState}
            applyBtnClickHandler={() => {
              props.handleApplyFilter(
                true,
                selectedBrands,
                selectedCountries,
                selectedStates,
                selectedCities,
                isTaxSliderActive
              );
            }}
            clearButtonLabel={model?.clearFilters}
            applyLabel={model?.storefrontPropertyFilterApply}
            className="modal-footer"
            clickTrackingLoc={'SEARCH_FILTER_MODAL'}
            applyBtnClickTrackValue={`${model?.id}|${model?.storefrontPropertyFilterApply}|${INTERNAL_CTA_TYPE}`}
            clearBtnClickTrackValue={`${model?.id}|${model?.clearFilters}|${INTERNAL_CTA_TYPE}`}
          />
        </Modal>
      )}
    </StyledSearchAllFilters>
  );
};
